'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _helpers = require('./_helpers');

var _swiperEsm = require('swiper/dist/js/swiper.esm.js');

/* prettier-ignore */
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');
  var swiperThumbsContainer = context.getElement('.' + context.className + '_Thumbs');
  var swiperPaging = context.getElement('.' + context.className + '_Paging');

  var galleryThumbs = (0, _helpers.initialiseSwiper)(swiperThumbsContainer, {
    spaceBetween: 10,
    slidesPerView: 5,
    centeredSlides: true,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true
  }, [_swiperEsm.Thumbs]);

  (0, _helpers.initialiseSwiper)(swiperContainer, {
    thumbs: {
      swiper: galleryThumbs
    },
    loop: false,
    slidesPerView: 1,
    slideClass: context.className + '_Slide',
    pagination: {
      el: swiperPaging,
      type: 'bullets',
      clickable: true,
      bulletClass: 'prd-ProductImage_Bullet',
      bulletActiveClass: 'prd-ProductImage_Bullet-active'
    }
  }, [_swiperEsm.Pagination]);
}